export default __webpack_public_path__ + "static/media/toggle.3501dc93.jpg";